<template>
  <h2>Danh sách Nhân viên</h2>
  <el-button type="success" @click="dialogStaff = true">Thêm mới</el-button>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column fixed prop="no" label="STT" width="100" />
    <el-table-column prop="code" label="Mã nhân viên" width="150" />
    <el-table-column prop="name" label="Tên nhân viên" width="200" />
    <el-table-column prop="email" label="Email" width="200" />
    <el-table-column align="right" width="300">
      <template #header>
        <el-input v-model="query.keySearch" size="default" placeholder="Tìm kiếm...." @change="getList()" />
      </template>
      <template #default="scope">
        <el-button size="small" @click="handleEdit(scope.row)">
          Edit
        </el-button>
        <el-button
            size="small"
            type="danger"
            @click="handleDelete(scope.row)"
        >
          Delete
        </el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-pagination
      size="small"
      background
      layout="prev, pager, next"
      :page-size="query.size"
      :total="query.total"
      class="mt-4"
      @current-change="handleCurrentChange"
  />
  <el-dialog v-model="dialogStaff" title="Thông tin nhân viên" width="500">
    <el-form :model="form" label-width="auto">
      <el-form-item label="Mã nhân viên">
        <el-input v-model="form.code" autocomplete="off" />
      </el-form-item>
      <el-form-item label="Tên nhân viên">
        <el-input v-model="form.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="Email">
        <el-input v-model="form.email" autocomplete="off" />
      </el-form-item>
      <el-form-item label="Mật khẩu">
        <el-input v-model="form.password" autocomplete="off" />
      </el-form-item>
      <p>
        <el-text class="mx-1" type="danger" style="font-style: italic">{{msgErr}}</el-text>
      </p>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogStaff = false">Hủy</el-button>
        <el-button type="primary" @click="save()">
          Lưu
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import {ElNotification, ElTable, ElTableColumn} from "element-plus";
import {onMounted, reactive, ref} from 'vue'
import {list, create, deleteStaff, update} from '@/api/staff'

let tableData = ref([])
const dialogStaff = ref(false)
const query = reactive({
  page: 1,
  size: 20,
  total: 0,
  keySearch: ''
})
const form = reactive({
  id: '',
  code: '',
  name: '',
  email: '',
  password: '',
})
let msgErr = ref('')

const handleEdit = (item) => {
  Object.assign(form, {
    id: item._id,
    code: item.code,
    name: item.name,
    email: item.email,
  })
  dialogStaff.value = true
}

const handleDelete = async (item) => {
  return deleteStaff(item._id).then(() => {
    getList()
  }).catch(e => {
    ElNotification({
      title: 'Error',
      message: e,
      type: 'error',
    })
  })
}

const save = async () => {
  try {
    if(!form.id) {
      await create(form)
    } else {
      await update(form.id, form)
    }
    await getList()
    resetData()
    dialogStaff.value = false
  } catch (e) {
    msgErr.value = e
  }
}

const handleCurrentChange = (val) => {
  query.page = val
  getList()
}

const resetData = () => {
  Object.assign(form, {
    id: '',
    code: '',
    name: '',
    email: '',
    password: '',
  })
  msgErr.value = ''
}

const getList = () => {
  return list(query.page, query.size, query.keySearch)
      .then(res => {
        tableData.value = res.list.map((item, idx) => {
          return {
            no: idx + 1,
            ...item,
          }
        })
        query.total = res.total
      })
}

onMounted(() => {
  getList()
})
</script>
